<template>
  <div class="bill_content_wrap">
    <h2>CHI TIẾT CÁC KHOẢN LƯƠNG</h2>
    <div class="bill_content px-4" style="border: 1px solid #e0e0e0; border-radius: 4px">
      <ChildGroupFeeExcel title="Khoản lương" :collections="report.sumFees" />
      <ChildGroupFeeExcel
        title="Thuế"
        :totalAmount="report.totalTax"
        :collections="report.taxFees"
        forceTotalAmountShown
      />
      <ChildGroupFeeExcel title="Khoản truy thu" :collections="report.minusFees" />
      <div class="total_money pb-4">
        <h3>Tổng lương thực lĩnh</h3>
        <span>{{ report.totalAfterTax | price }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ChildGroupFeeExcel from './ChildGroupFeeExcel.vue'
export default {
  components: {
    ChildGroupFeeExcel,
  },
  computed: {
    ...mapGetters({
      report: 'salaryReport/report',
      collections: 'salaryCollection/collections',
    }),
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.bill_content {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.total_money h3 {
  font-weight: bold;
  font-size: 18px !important;
}
</style>
